import React, { useState } from "react";
import Title from "../components/Title";
import PersonalInfo from "../components/personalInfo/PersonalInfo";
import ChangePassword from "../components/changePassword/ChangePassword";
import NotificationSettings from "../components/notificationSetting/NotificationSettings";
import NavigationBar from "../components/navigationBar/NavigationBar";

export default function MyProfile() {
  const [activeButton, setActiveButton] = useState(1);
  return (
    <div>
      <Title text={"My Profile"} />
      <div>
        <NavigationBar
          activeButton={activeButton}
          setActiveButton={setActiveButton}
        />
        {activeButton === 1 && <PersonalInfo />}
        {activeButton === 2 && <ChangePassword />}
        {activeButton === 3 && <NotificationSettings />}
      </div>
    </div>
  );
}
